<template>
    <div class="fade-in" id="atlas">
        <TopBar/>
        <LeftBar :customers="customers" @setCustomerSelected="setCustomerSelected"/>
        <div class="content-page">
            <div class="content">
                <transition name="fade" mode="out-in">
                    <APILoading key="loading-API" :text="loadingAPIText" v-if="isAPIAvailable === undefined" :category="$firstSectionPath"/>
                    <APIUnavailable key="unavailable-API" v-else-if="isAPIAvailable === null" :category="$firstSectionPath"/>
                    <router-view v-else key="content" class="fade-in" :customers="customers"/>
                </transition>
            </div>
        </div>
<!--        <footer class="footer">-->
<!--            <span>2019 © OhMyCode.</span>-->
<!--            <img alt="omc-logo" class="pull-right" src="http://www.oh-my-code.com/images/logo.png" width="50"/>-->
<!--        </footer>-->
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import TopBar from "./TopBar/TopBar";
import LeftBar from "./LeftBar/LeftBar";
import Customer from "../../classes/Customer";
import APIUnavailable from "../shared/API/APIUnavailable";
import APILoading from "../shared/API/APILoading";

export default {
    name: "Atlas",
    components: { APILoading, APIUnavailable, LeftBar, TopBar },
    data() {
        return {
            customers: undefined,
            countries: undefined,
        };
    },
    computed: {
        ...mapGetters("hermesAPIConfig", {
            hermesAPIConfig: "hermesAPI",
        }),
        ...mapGetters("diceAPIConfig", {
            diceAPIConfig: "diceAPI",
        }),
        isAPIAvailable() {
            const section = this.$firstSectionPath;
            const sectionAPIs = {
                distribution: this.hermesAPIConfig,
                billing: this.diceAPIConfig,
            };
            return sectionAPIs[section];
        },
        loadingAPIText() {
            const section = this.$firstSectionPath;
            return this.$t(`APILoading.connexion.${section}`);
        },
    },
    async created() {
        if (!await this.checkUserAuthentication()) {
            return;
        }
        this.getHermesAPIConfig();
        this.getDiceAPIConfig();
        this.getCountries();
        this.getCurrencies();
        await this.getCustomers();
        this.retrieveSelectedCustomer();
    },
    methods: {
        ...mapActions("user", {
            checkUserAuthentication: "checkUserAuthentication",
        }),
        ...mapActions("hermesAPIConfig", {
            getHermesAPIConfig: "getHermesAPIConfig",
        }),
        ...mapActions("diceAPIConfig", {
            getDiceAPIConfig: "getDiceAPIConfig",
        }),
        ...mapActions("currencies", {
            getCurrencies: "getCurrencies",
        }),
        ...mapActions("countries", {
            getCountries: "getCountries",
        }),
        getCustomers() {
            return new Promise(resolve => {
                // setTimeout(() => {
                this.customers = [];
                this.customers.push(new Customer({ id: 0, firstName: this.$t("Atlas.all"), selected: true }));
                this.customers.push(new Customer({ id: 1, firstName: "Antoine", lastName: "ZANARDI" }));
                this.customers.push(new Customer({ id: 2, firstName: "Thibault", lastName: "MESURE" }));
                this.customers.push(new Customer({ id: 3, firstName: "Mathieu", lastName: "FRANÇOIS" }));
                return resolve();
                // }, 3000);
            });
        },
        setCustomerSelected(id) {
            let isFound = false;
            for (const customer of this.customers) {
                if (customer.id === id) {
                    customer.selected = true;
                    isFound = true;
                    localStorage.setItem("selectedCustomerId", id);
                } else if (customer.selected) {
                    customer.selected = false;
                }
            }
            if (!isFound) {
                this.setCustomerSelected(0);
                localStorage.setItem("selectedCustomerId", id);
            }
        },
        retrieveSelectedCustomer() {
            const selectedCustomerId = localStorage.getItem("selectedCustomerId");
            if (selectedCustomerId) {
                this.setCustomerSelected(parseInt(selectedCustomerId));
            }
        },
    },
};
</script>

<style>
</style>